import type { DoBoxWorkKind } from './doBoxSignals';

export enum AgentRouteMode {
  SUGGEST = 'SUGGEST',
  ASSIGN_AND_PLAN = 'ASSIGN_AND_PLAN',
  ASSIGN_AND_ACT = 'ASSIGN_AND_ACT',
}

export enum AgentRouteStatus {
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
}

export enum AgentRouteTargetKind {
  RESOLVER = 'RESOLVER',
  AGENT_TEMPLATE = 'AGENT_TEMPLATE',
}

/**
 * A learned/declared mapping from a recurring trigger (a counterpart, a thread, a work kind)
 * to the agent or resolver that should handle it, and how much autonomy it gets — the
 * `AgentRoutes` table behind the router. No free text: every trigger is a key or an HMAC
 * digest, and the target is always an id, never a label the model wrote.
 */
export interface AgentRoute {
  userId: string;
  routeId: string;
  mode: AgentRouteMode;
  status: AgentRouteStatus;
  targetKind: AgentRouteTargetKind;
  // The resolver name (targetKind RESOLVER) or AgentTemplate id (targetKind AGENT_TEMPLATE)
  // this route dispatches to.
  targetId: string;
  // Keyed hmacEmail/hmacPlatformIdentity digest of who this route triggers on — compared,
  // never displayed.
  counterpartKeyHmac?: string;
  threadKeyHmac?: string;
  workKind?: DoBoxWorkKind;
  useCount: number;
  undoCount: number;
  createdAt: number;
  updatedAt: number;
}
